import { Tooltip } from "antd";
import MaterialLikeSelect from "./MaterialLikeSelect";
import { RiResetLeftLine } from "react-icons/ri";

const AdvancedFilter = ({
  visible,
  filters = [],
  values = {},
  onChange,
  onReset,
}) => {
  if (!visible) return null;

  return (
    <div className=" w-full bg-white mb-5 flex gap-3 items-center justify-between">
      <div className="flex w-full  gap-4">
        {filters.map((filter) => (
          <div key={filter.name} className="w-full">
            <MaterialLikeSelect
              allowClear={true}
              label={filter.label}
              value={values[filter.name] || ""}
              options={filter.options || []}
              onChange={(value) => onChange(filter.name, value)}
            />
          </div>
        ))}
      </div>

      <div className="">
        <Tooltip title='Reset'>
          <RiResetLeftLine onClick={onReset} className="!text-3xl" />
        </Tooltip>
      </div>
    </div>
  );
};

export default AdvancedFilter;
